
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqvVAR67PiidGGkvcaf1s6NnE2QYGo3GtF4axgOHDGGVIMeta } from "/codebuild/output/src674100801/src/src/pages/faq.vue?macro=true";
import { default as menumE9gQprMSIaBIilxMSE4kmxpf1kpXo_K_OYuYe1YU6EMeta } from "/codebuild/output/src674100801/src/src/pages/menu.vue?macro=true";
import { default as indexe5cgCgo3uMWTSr2_45v0Hkyv_45cEn0uHzrXycK2Q8gSbEsMeta } from "/codebuild/output/src674100801/src/src/pages/index.vue?macro=true";
import { default as contactpQfxgbKRPYVzk9hlsOiENwE9teRZ2SpsmKH_f9CpIJQMeta } from "/codebuild/output/src674100801/src/src/pages/contact.vue?macro=true";
import { default as tutorialq7MlRQqNHja7E63bdWLVC_MBu_OnSKzAuEcmSmWkoskMeta } from "/codebuild/output/src674100801/src/src/pages/tutorial.vue?macro=true";
import { default as agreementBLJfXmCWYcyuLoaQa2KF098obnirbnCVVKj7dpmuQ5MMeta } from "/codebuild/output/src674100801/src/src/pages/agreement.vue?macro=true";
import { default as about_45passNnkmW86QFUorMqtdK5OYLmdNqlwdi5Ja3mPXDinkC_458Meta } from "/codebuild/output/src674100801/src/src/pages/about-pass.vue?macro=true";
import { default as index_jzHP8KR9L3ualR3OB6alO4VMHkA2YShAbmPC3rchCYMeta } from "/codebuild/output/src674100801/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93FV_45TwI7mJRVt11fMA_epLTKGmIvx53GUFC8r1IsZJJMMeta } from "/codebuild/output/src674100801/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance_459QOhJbYAmQnfJCrXpK4GUY3ucV4LzCBjUk7pYX2DqcMeta } from "/codebuild/output/src674100801/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93UoGEHkVyWYBNMeoggn_45dgYdD9JMCOh_rONWr7I6ORxcMeta } from "/codebuild/output/src674100801/src/src/pages/notice/[id].vue?macro=true";
import { default as indexQCSErieat7SVlQWiLekEEGx_45Lz8Rps8MhPn6X3w_MDMMeta } from "/codebuild/output/src674100801/src/src/pages/coupon/index.vue?macro=true";
import { default as indexPLr0a0_BsFm6dzX9CdEZmTxJs_45cbAU3EAb0ZuMIF3RcMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/index.vue?macro=true";
import { default as indexo_pp9zW8y379BxaDSagMTfJUJy6hn4G20npcTKBjecMMeta } from "/codebuild/output/src674100801/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93vc3N_459sDpHlh_45P_0L4UzNPPNpmxy46WeeRW_45MbAOef0Meta } from "/codebuild/output/src674100801/src/src/pages/parking/[id].vue?macro=true";
import { default as index79Vk1OSdSqKizY8vk0vMpTNJL42Ny5ySQCUPGC_YlVYMeta } from "/codebuild/output/src674100801/src/src/pages/history/index.vue?macro=true";
import { default as indexFKOnC0Y9NqXGQyepjgEvFM57KAyVLJbjgDbjvCODtX4Meta } from "/codebuild/output/src674100801/src/src/pages/monthly/index.vue?macro=true";
import { default as indexSC_45PV_4z3BmlyaCv0_45WsdSprMNjrsXT17vzbJP3Uq_sMeta } from "/codebuild/output/src674100801/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexJpgdJQg_452BZPFsXYApKLpOZCR2or27yv_45EUbqfl5Ag0Meta } from "/codebuild/output/src674100801/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviLllT0oT9cegrXmlUHnLWovEEfbelHaAoAiHS94JCAoAMeta } from "/codebuild/output/src674100801/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit_zcEQX7i4TayknvbxeGGMm9TXvFWO1WJKSyBj6B8zj0Meta } from "/codebuild/output/src674100801/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementMLEl7JX4NRaG2sb0S_45qbk7ybznEgqNNtS5Z6ixh2wBoMeta } from "/codebuild/output/src674100801/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexgw5TFfBFsFtBD6h725gG4hhWyVa_45HK8Vu7TaiQ8_45GwYMeta } from "/codebuild/output/src674100801/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dIPbYqgbNR7PyiLnrg8VWBIUjQvnzM6m1b4agR9aJissMeta } from "/codebuild/output/src674100801/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmZm1P5_45A_458PkGD5JV48Ljb2l_SdvLm_CX4NnvskVHUuUMeta } from "/codebuild/output/src674100801/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexRnzqIa4sEtpArf38an_45_45uvAthNIyE01vYdq3ZLGynDgMeta } from "/codebuild/output/src674100801/src/src/pages/card/create/index.vue?macro=true";
import { default as indexuwAZYqBSCr0R6HixScKwJLcizkS6BEUOg4nXdoanQ5AMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmgoxhIZhLz1Wgs99z1Pr1_6lngSzrH7_AklzB1FItRPUMeta } from "/codebuild/output/src674100801/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmBNHiGVxJwFwkx0DCi07QHLt_Mk3KyTr7KQ3v6uKnrAEMeta } from "/codebuild/output/src674100801/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completee1rk6Wgeoqbtx7D_45AP4uYfmIEfHFBlxJ8DpEL3JMFYsMeta } from "/codebuild/output/src674100801/src/src/pages/membership/complete.vue?macro=true";
import { default as registerlpWqQxLsKIOojNIJ3c0q8fbjTIEGJJhoSfcjq1e9rjkMeta } from "/codebuild/output/src674100801/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93I3zVI2XHxjfBK9lQ7_xBOcPZkwLzcTod7t3Pskqc2xsMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmaziGcWzfinfLjkjRJ4gspO6RMBWHjnL_wzcxT3lpL9YMeta } from "/codebuild/output/src674100801/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93e2VQAbOj5FToPqLhL5vpOjv1X0ll4l6cX6arp5o_45mEMMeta } from "/codebuild/output/src674100801/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexESYhGR6hgLuCrgGPCXfMH_3GmgmxzJZahLNq4cLQBvwMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeZmAcMjOIh_45Rku1E_45Elrfwca_4564IK5eesoKyYWx_45VJ6MMeta } from "/codebuild/output/src674100801/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codewSCLCGgOe5G_45_hhJZ7c7BGc0DurKfJmgbI89jwL_45CmUMeta } from "/codebuild/output/src674100801/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeK_c3eCGuLyMadK_KCKkFZ8phdQX1PgW_dfu6W2IZos0Meta } from "/codebuild/output/src674100801/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerImbuEiz2F1k4kx_45e8M8GmH2xRwQpCh4AFCcBhkq_453MoMeta } from "/codebuild/output/src674100801/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeogl90e2SaBYjfKxTP8ir079Ky_45u146wwnJhF3xxtgvYMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index3NLc_45B_KJ2D39FhRo0DfkMRiNE04UzijP1w0PyRd4I8Meta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmNrKY_9aSzmkpHuyRzFINsNZz9J56nEUQnh08mMyclM0Meta } from "/codebuild/output/src674100801/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete2glRcaJGU4IDo7ePUK17MtH8TXQnJ8qjemNm9Fv2pVMMeta } from "/codebuild/output/src674100801/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexLamZO69irD79_45qqjaepGVKZbGCguMdKk1Kkh0kAx_M0Meta } from "/codebuild/output/src674100801/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93ju8zXdN8uYdpn7ImGgXZpwsMlaC7EiUVW1u6Ysk1e8oMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeMMU9_IBrbgLqkhgdhvoUm4JZDl20ZQv65KQjFcgFm1oMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliascULLbPWnBHP7F1QQK2Q2any5VhTcKy7EEPXhUlCjmZYMeta } from "/codebuild/output/src674100801/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample8ISPXVTwGkXBoHnhaJroqs7GFVOXgAs57EJyK8AkW_cMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email1hyERdYOJEAjVtEalRjRSI_LvBD9LgkqbgKtlYijgXkMeta } from "/codebuild/output/src674100801/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmuQ7C3BTlLosA40Mdx5RWbEm3QWFXeCDLpBq0qfJ66c4Meta } from "/codebuild/output/src674100801/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentCpykgXH_459xQC1CbNVixf5o4umPkIereNmj_45y3Moled0Meta } from "/codebuild/output/src674100801/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmfhkwvLg5G0SxmH54s2xKFT4EMkmvjB_45SgpmLuGIICckMeta } from "/codebuild/output/src674100801/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatepLCWvRpZKkTx1hU3IQ0xIKg1LLzc4RSnphadMhJZDPsMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeJmP8hyvpieMLXrwoncmQzLdyMEyThcgI6Jf9ZFbWE8AMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codepP3AvXc7KRvMjkyURUDi36vmvoF2O61YpROMLyHDU2AMeta } from "/codebuild/output/src674100801/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordhabR0uWc3oDtyogXvicebU5J8RpanHNgYDYtjnpAH0kMeta } from "/codebuild/output/src674100801/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasoFtVjdpHtvO_459SylcMwjTc8Mkm1M_d0Ri70DVJ3i52UMeta } from "/codebuild/output/src674100801/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registervOpNWtcFvVQbQs75NfYH3mnR_XYwKwQPao6kmEckg9MMeta } from "/codebuild/output/src674100801/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codevkuOsQRejZVyPBjea3n_45vlczQeHVSdEnOG1xK1DCjwUMeta } from "/codebuild/output/src674100801/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexnXiWYYGiXoNFX8xrwnoDrsW6DGCDaw1otNimy4vNWYsMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexu_rUtmGVMvp496aGq7F5uP05rulxxnH_452O9IhJs_45NboMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexSX6Owl_45XNn6nqPilFdmZWHCK9Wh0J_45uztku_oj4clK0Meta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexvvWrUEf_45RbD8qJZwfE7kdWLvEJmmZXgG86q2S4vhaIcMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateWt91lKqe8ArfC2LgiSvgdMbtZLoE3pQZvLQklwBzHYEMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete_2wnwKJ3rwFMCbb7OW_45cazZx4NkklwHzkf91Vrb_45SRgMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmknaJoczXpBQkz8gySIOAU_45xI28KauKp_9X9mOfHVl6gMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexpvqf4XqisWnIINEtFaRTA4uMMqoRzzTGtFbdMQPiCtQMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeykkzNYEBT5orlMJhNp83XTUie7Knmr2iuEmOW5rgCikMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update5rtYXsh43pGyxguEIidbNo1NbVRpa95MpsVQo0_n5uAMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexIl157jvKVKOhW5NioWu_45UKpUNlndd6KM9r1ZfG0yKjwMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexmVtaFJK0PqPBxWKZTQNgE7V_EGPoSicmPMcjCuVqb38Meta } from "/codebuild/output/src674100801/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeZ32q_45ZUXFm6hWi5P3b_LMd7ZfExNnn9auDojaLcwc6EMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexMgMAJ_rhirZzyJdSjJAohstMtEUX4EXgQ1K0gTOH2AQMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeFRi2eaQ1eOG_45_45kdbytT4BuWLnumEL1wrBtSyHhYZhF8Meta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexoUSdjespVi30mI59Kdt5HEVUaLWEp8ZhvDpNl6pDwUoMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexVQaU8zJITpRx6lDgUGtJ4Ghs_HAiCffOVRnzv7sLIfQMeta } from "/codebuild/output/src674100801/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexEIwV5FlYvlhKXhP_3xVyOIl7L1gBH9ZVIe0KC6dDAJ4Meta } from "/codebuild/output/src674100801/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatevZBviUcWo5qSV1iVzgnE63ns4yXF3nRJ_6bEh3YYRqYMeta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmYYOtnt6VextxyRhJQJl77yxfdnSMVvQwQFLCDSa0HU4Meta } from "/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src674100801/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menumE9gQprMSIaBIilxMSE4kmxpf1kpXo_K_OYuYe1YU6EMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexe5cgCgo3uMWTSr2_45v0Hkyv_45cEn0uHzrXycK2Q8gSbEsMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src674100801/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src674100801/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src674100801/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src674100801/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src674100801/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexQCSErieat7SVlQWiLekEEGx_45Lz8Rps8MhPn6X3w_MDMMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src674100801/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src674100801/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index79Vk1OSdSqKizY8vk0vMpTNJL42Ny5ySQCUPGC_YlVYMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexSC_45PV_4z3BmlyaCv0_45WsdSprMNjrsXT17vzbJP3Uq_sMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexJpgdJQg_452BZPFsXYApKLpOZCR2or27yv_45EUbqfl5Ag0Meta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src674100801/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src674100801/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexRnzqIa4sEtpArf38an_45_45uvAthNIyE01vYdq3ZLGynDgMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmgoxhIZhLz1Wgs99z1Pr1_6lngSzrH7_AklzB1FItRPUMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmBNHiGVxJwFwkx0DCi07QHLt_Mk3KyTr7KQ3v6uKnrAEMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completee1rk6Wgeoqbtx7D_45AP4uYfmIEfHFBlxJ8DpEL3JMFYsMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerlpWqQxLsKIOojNIJ3c0q8fbjTIEGJJhoSfcjq1e9rjkMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmaziGcWzfinfLjkjRJ4gspO6RMBWHjnL_wzcxT3lpL9YMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeZmAcMjOIh_45Rku1E_45Elrfwca_4564IK5eesoKyYWx_45VJ6MMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codewSCLCGgOe5G_45_hhJZ7c7BGc0DurKfJmgbI89jwL_45CmUMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeK_c3eCGuLyMadK_KCKkFZ8phdQX1PgW_dfu6W2IZos0Meta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerImbuEiz2F1k4kx_45e8M8GmH2xRwQpCh4AFCcBhkq_453MoMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmNrKY_9aSzmkpHuyRzFINsNZz9J56nEUQnh08mMyclM0Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete2glRcaJGU4IDo7ePUK17MtH8TXQnJ8qjemNm9Fv2pVMMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexLamZO69irD79_45qqjaepGVKZbGCguMdKk1Kkh0kAx_M0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeMMU9_IBrbgLqkhgdhvoUm4JZDl20ZQv65KQjFcgFm1oMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample8ISPXVTwGkXBoHnhaJroqs7GFVOXgAs57EJyK8AkW_cMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email1hyERdYOJEAjVtEalRjRSI_LvBD9LgkqbgKtlYijgXkMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmuQ7C3BTlLosA40Mdx5RWbEm3QWFXeCDLpBq0qfJ66c4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentCpykgXH_459xQC1CbNVixf5o4umPkIereNmj_45y3Moled0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmfhkwvLg5G0SxmH54s2xKFT4EMkmvjB_45SgpmLuGIICckMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeJmP8hyvpieMLXrwoncmQzLdyMEyThcgI6Jf9ZFbWE8AMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codepP3AvXc7KRvMjkyURUDi36vmvoF2O61YpROMLyHDU2AMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordhabR0uWc3oDtyogXvicebU5J8RpanHNgYDYtjnpAH0kMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src674100801/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registervOpNWtcFvVQbQs75NfYH3mnR_XYwKwQPao6kmEckg9MMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codevkuOsQRejZVyPBjea3n_45vlczQeHVSdEnOG1xK1DCjwUMeta || {},
    component: () => import("/codebuild/output/src674100801/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src674100801/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src674100801/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]